import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_1204 implements Validator {

	public static id = 'CTRL_1204';
	private message = 'error.ctr_1204';


	public LOG: LogService = new LogService(CTRL_1204);


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1204.id + '_');

		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const motsClefNameWithStepId = map.get(ctrl.value.rgCtrls.motsClef);
				const motsClefCtrl = form.controls[motsClefNameWithStepId];
				if (motsClefCtrl.value.length > 0) {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				} else {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				}
			}
		}
	}
}
